import type { FC } from 'react'
import React, { Fragment } from 'react'

import FunctionalCarousel from '@vfuk/core-functional-carousel'
import { getDataSelector } from '@vfuk/core-base-props'

import type { BannerCarouselProps } from './BannerCarousel.types'

const BannerCarousel: FC<BannerCarouselProps> = ({
  id,
  srName,
  waitTime,
  showNavigation,
  banners,
  dataSelectorPrefix,
  dataAttributes,
}: BannerCarouselProps) => {
  const componentName = 'BannerCarousel'

  return (
    <FunctionalCarousel
      id={id}
      srName={srName}
      slidesToShow={{ sm: 1, md: 1, lg: 1, xl: 1 }}
      transitionSpeed={500}
      pager={{
        type: 'loader',
        titles: banners.map(({ title }) => title),
        timeout: waitTime,
        showNavigation,
      }}
      dataSelectorPrefix={getDataSelector(dataSelectorPrefix)}
      dataAttributes={{ 'data-component-name': componentName, ...dataAttributes }}
    >
      {banners.map(({ child }, index) => (
        <Fragment key={index}>{child}</Fragment>
      ))}
    </FunctionalCarousel>
  )
}

export default BannerCarousel
